import React, { useState } from "react"
import styled from "@emotion/styled"

import { ErrorMessage } from "../common"
import { email, invalidEmail } from "../../services/validator"
import VisibilitySensor from "../visibility-sensor"
import ShakingButton from "../shaking-button"

import {
  message,
  formError,
  serverError,
  formSuccess,
} from "../../services/toast"
import theme from "../../styles/theme"

const ContactFom = () => {
  const [loading, setLoading] = useState(false)
  const [emailValue, setEmailValue] = useState("")
  const [emailError, setEmailError] = useState("")

  const resetForm = () => {
    setEmailValue("")
  }

  const validate = () => {
    const isValid = email.test(emailValue)
    setEmailError(isValid ? "" : invalidEmail)
    return isValid
  }

  const onSubmit = async e => {
    setLoading(true)
    e.preventDefault()
    if (validate()) {
      try {
        const response = await fetch("/.netlify/functions/sendmail", {
          method: "POST",
          body: JSON.stringify({ email: emailValue, newsLetter: true }),
        })
        if (response.status === 200) {
          message("success", formSuccess)
          resetForm()
        } else {
          message("error", serverError)
        }
      } catch (e) {
        message("error", serverError)
      } finally {
        setLoading(false)
      }
    } else {
      message("error", formError)
      setLoading(false)
    }
  }

  return (
    <StyledForm onSubmit={onSubmit}>
      <input
        className={!!emailError ? "error" : ""}
        value={emailValue}
        onChange={e => setEmailValue(e.target.value)}
        placeholder="martin@email.com"
        type="text"
      />
      <VisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <StyledShakingButton
            disabled={loading}
            type="submit"
            className={isVisible ? "visible" : ""}
          >
            Envoyer
          </StyledShakingButton>
        )}
      </VisibilitySensor>
      <StyledErrorMessageWrapper>
        <ErrorMessage>{emailError}</ErrorMessage>
      </StyledErrorMessageWrapper>
    </StyledForm>
  )
}

const StyledForm = styled.form`
  position: relative;
  display: block;
  @media only screen and (min-width: ${theme.breakpoint.medium}px) {
    display: flex;
  }
`

const StyledShakingButton = styled(ShakingButton)`
  margin-top: 1rem;
  @media only screen and (min-width: ${theme.breakpoint.medium}px) {
    margin-left: 1rem;
    margin-top: 0;
    width: 160px;
  }
`

const StyledErrorMessageWrapper = styled.div`
  position: absolute;
  bottom: 40px;
  @media only screen and (min-width: ${theme.breakpoint.medium}px) {
    bottom: -1.2em;
  }
`
export default ContactFom
